import { LoadableAfterPaint } from '@confluence/loadable';

export const ActivityFilterDialog = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ActivityFilterDialog" */ '../src/ActivityFilterDialog.tsx'
			)
		).ActivityFilterDialog,
});
